import React, { useState, useEffect, Component } from 'react';
import { checkMenu } from '../Utils/Common';
import history from '../Utils/History';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import { AiOutlineRollback } from "react-icons/ai";
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { useHistory, useParams, Link } from 'react-router-dom';

import '../assets/css/dropzone.min.css';
import UploadFiles from '../component/UploadFiles';
import 'bootstrap/dist/css/bootstrap.min.css';

export const Upload = () => {
	const history = useHistory()
	const [types, setTypes] = useState([]);
	const [projects, setProjects] = useState([]);
	const [error, setError] = useState(null);
	const [errorForm, setErrorForm] = useState([]);
	const [validated, setValidated] = useState(false);
	const [defaultSelectedType, setDefaultSelectedType] = useState({});
	const [defaultSelectedProject, setDefaultSelectedProject] = useState({});
		
	const [formData, setFormData] = useState({
		type: '',
		projectId: '',
	});

	const typeList = [
		{
			title: 'Project',
		},
		{
			title: 'Client',
		},
		{
			title: 'News',
		},
		{
			title: 'Leadership',
		},
		{
			title: 'Banner',
		},
		{
			title: 'Document',
		},
		{
			title: 'Content',
		},
	]

	useEffect(() => {
		getTypes(defaultSelectedType)
		// getProjectList(defaultSelectedProject)
	}, []);

	const getProjectList = async (selectedProject) => {
		await Api().get(`projects/all`)
		.then((response) => response)
		.then((respProjects) => {
			if( respProjects.status === 200 )
			{	
				const listProject = respProjects.data;
				for( let i=0; i < listProject.length; i++)
				{
					var selected = false
					if( listProject[i].title === selectedProject )
					{
							selected = true;
					}
					listProject[i].selected = selected
				}
				console.log(listProject);
				setProjects(listProject);
			}
		})
		.catch((err) => {
		})
	}

	const getTypes = (selectedType) => {
		for( let i=0; i < typeList.length; i++)
		{
			var selected = false
			if( typeList[i].title === selectedType )
			{
					selected = true;
			}
			typeList[i].selected = selected
		}
		console.log(typeList);
		setTypes(typeList);
	}

	const handleChangeSelect = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		if( key === 'type')
		{
			setDefaultSelectedType(value)
			if( value === 'Project' )
			{
				getProjectList(defaultSelectedProject)
			}
		}
		setFormData({...formData, [key]: value})
		console.log(formData)
	}

	return (
		<>
			<div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
				<DefaultLayout />
				<main>
					<div className="content-header">
						<Container fluid>
							<Row className="mb-2">
								<Col sm={6}>
									<h1 className="m-0">Upload File(s) Medical Record</h1>
								</Col>
								<Col sm={6}>
									<Breadcrumb className="breadcrumb float-sm-right">
										<Breadcrumb.Item href="/">Home</Breadcrumb.Item>
										<Breadcrumb.Item href="/filemanager">Medical Record File Manager</Breadcrumb.Item>
										<Breadcrumb.Item active>Upload File(s)</Breadcrumb.Item>
									</Breadcrumb>
								</Col>
							</Row>
						</Container>
					</div>
								
					<div className="content">
						<Container fluid>
								<Row>
									<Col lg={12}>
										<Card className="content-list">
											<Card.Header>
												{ checkMenu('filemanager') &&
													<Link to="/filemanager"><Button variant="outline-primary"><AiOutlineRollback /> Back</Button></Link>
												}
											</Card.Header>
											<Card.Body>
												<Col md="12">
													<Form>
														<Row className="mb-3">
															<Form.Group as={Col} md="4" controlId="validationCustom08">
																<Form.Label>Type</Form.Label>
																<Form.Control
																	required
																	as="select"
																	name="type"
																	defaultValue={defaultSelectedType}
																	// value={defaultSelectedType}
																	onChange={handleChangeSelect}
																>
																	<option value="">Select Type</option>
																	{
																		types.map((item, i) => (
																			<option key={i} value={item.title} selected={item.selected}>{item.title}</option>
																		))
																	}
																</Form.Control>
															</Form.Group>
														</Row>
														{ defaultSelectedType === 'Project' &&
															<Row className="mb-3">
																<Form.Group as={Col} md="4" controlId="validationCustom08">
																	<Form.Label>Project</Form.Label>
																	<Form.Control
																		required
																		as="select"
																		name="projectId"
																		defaultValue={defaultSelectedProject}
																		// value={defaultSelectedType}
																		onChange={handleChangeSelect}
																	>
																		<option value="">Select Project</option>
																		{
																			projects.map((item, i) => (
																				<option key={i} value={item._id} selected={item.selected}>{item.projectName}</option>
																			))
																		}
																	</Form.Control>
																</Form.Group>
															</Row>
														}
														<UploadFiles
																formData={formData}
																defaultSelectedType={defaultSelectedType}
														/>
													</Form>
												</Col>			
											</Card.Body>
										</Card>
									</Col>
								</Row>
							</Container>
					</div>
				</main>
			</div>
			<Footer />
		</>
	)
}

export default (Upload);
